import React from "react";
import { motion } from "framer-motion";

const paragraphs = [
  "We are a collective of creatives brought together by a shared passion for art in all its forms — and by the belief that art thrives when people connect.",
  "With our diverse backgrounds and experiences, we aim to bridge cultures and perspectives, bringing artists and audiences together in inspiring new ways.",
  "Our mission is to curate and host unique art events across the United Kingdom, Turkey, and Greece, blending local influences with international creativity.",
  "Through our community and global network of collaborators, we strive to reimagine what an art event can be — more immersive, more inclusive, and more human.",
  "Together, we're building a space where art isn't just seen, but truly felt — a platform where creativity connects people beyond borders.",
];

export default function AboutUs() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#FAFAFA] border-t border-black/10 py-24 md:py-40 lg:py-48"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1 }}
            className="col-span-12 md:col-span-4 md:sticky md:top-32 self-start"
          >
            <span className="label">About Us</span>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-black mt-8">
              Art Begins
              <br />
              in <span className="italic font-light">Connection.</span>
            </h2>
            <div className="hidden md:block mt-10 h-px w-24 bg-black" />
          </motion.div>

          <div className="col-span-12 md:col-span-7 md:col-start-6 space-y-7 md:space-y-9 mt-4 md:mt-2">
            {paragraphs.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, delay: i * 0.08, ease: "easeOut" }}
                className="font-body font-light text-lg md:text-xl leading-relaxed text-black/80"
                data-testid={`about-paragraph-${i}`}
              >
                {p}
              </motion.p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
